<template>
  <div
    class="trade-container"
    :class="{
      'h5-trade-container': isH5,
      'electron-trade-container': isElectron,
    }"
  >
    <!-- tab-背景元素 -->
    <div v-if="!isH5" class="tab-bg-wrap"></div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="订单" name="order">
        <v-order v-if="activeName === 'order'" ref="order" />
      </el-tab-pane>
      <el-tab-pane label="退款" name="refund">
        <refund v-if="activeName === 'refund'" ref="refund" />
      </el-tab-pane>
      <el-tab-pane label="优惠券" name="coupon">
        <Coupon v-if="activeName === 'coupon'" ref="coupon" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import moment from "moment";
// import { getCourseList } from "@/api/learning-center/index";
import Coupon from "./components/Coupon";
import Order from "./components/Order.vue";
import Refund from "./components/Refund.vue";
export default {
  name: "Trade",
  components: { "v-order": Order, Refund, Coupon },
  data: function () {
    return {
      moment,
      activeName: "order",
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {
    activeName(val) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      }
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
      }
      if (document.getElementById("electron-main")) {
        document.getElementById("electron-main").scrollTop = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$tab-bg-height: 55px;
$tab-heiight: 46px;
.trade-container {
  padding-top: calc(#{$tab-heiight} + 15px + 15px);
  padding-bottom: 30px;
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 300px);
}
.tab-bg-wrap {
  position: fixed;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 1200px;
  height: $tab-bg-height;
  background: var(--page-bg, #f7f7f7);
  z-index: 8;
}
::v-deep {
  .el-tabs__header {
    height: $tab-heiight;
    background: var(--card-bg, #ffffff);
    border-radius: 16px;
    margin-bottom: 12px;
    position: fixed;
    top: calc(#{$nav-bar-height} + 15px);
    z-index: 9;
    width: 1200px;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__nav-wrap {
    padding: 0 0 0 15px;
    height: 100%;
  }
  .el-tabs__content {
    padding: 16px;
    background: var(--card-bg, #fff);
    border-radius: 24px;
  }
  .el-tabs__item {
    font-size: 16px;
    color: var(--text-secondary, #515350);
    line-height: 22px;
    height: 46px;
    padding-right: 0;
    margin: 0 25px;
    padding: 12px 0;
    font-weight: 400;
  }
  .el-tabs__item.is-active {
    font-weight: 600;
    font-size: 16px;
    color: var(--text-primary, #{$saas-text-color});
    line-height: 22px;
    position: relative;
    &::after {
      position: absolute;
      display: block;
      content: "";
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 19px;
      height: 4px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 3px;
    }
  }
  .el-tabs__item:hover {
    font-size: 16px;
    color: var(--text-secondary, #515350);
    line-height: 22px;
  }
  .el-tabs__active-bar {
    display: none;
  }
}
::v-deep {
  .el-table th.el-table__cell {
    background: var(--input-bg, #f2f3f5);
  }
  .el-table__row:last-child td.el-table__cell {
    border-bottom: none;
  }
  .el-table::before {
    display: none;
  }
}

// h5
.trade-container.h5-trade-container {
  // min-width: 1050px;
  max-width: 100%;
  padding-top: 0;
  ::v-deep {
    .el-tabs__header {
      height: auto;
      border-radius: 0;
      position: static;
    }
  }
}

$electron-tab-bg-height: 50px;
// electron
.trade-container.electron-trade-container {
  padding-top: $electron-tab-bg-height;
  padding-bottom: 30px;
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - #{$side-bar-width});
  .tab-bg-wrap {
    position: fixed;
    top: $top-bar-height;
    left: $side-bar-width;
    transform: none;
    display: block;
    width: calc(100vw - #{$side-bar-width});
    height: $electron-tab-bg-height;
    background: var(--page-bg, #fafafb);
    z-index: 8;
  }
  ::v-deep {
    .el-tabs__header {
      height: 30px;
      background: transparent;
      border-radius: 16px;
      margin-bottom: 14px;
      position: fixed;
      top: calc(#{$top-bar-height} + 5px);
      z-index: 9;
      width: 1200px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__nav-wrap {
      padding: 0;
      height: 100%;
    }
    .el-tabs__content {
      padding: 20px;
      background: var(--card-bg, #fff);
      border-radius: 16px;
    }
    .el-tabs__item {
      font-size: 14px;
      color: var(--text-secondary, #515350);
      line-height: 20px;
      height: 30px;
      padding-right: 0;
      margin: 0 15px;
      padding: 6px 0;
    }
    .el-tabs__item.is-active {
      font-weight: 500;
      font-size: 14px;
      color: var(--text-primary, #0d1400);
      line-height: auto;
      position: relative;
      &::after {
        position: absolute;
        display: block;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
    .el-tabs__item:hover {
      font-weight: 400;
      font-size: 14px;
      color: var(--text-secondary, #515350);
      line-height: 20px;
    }
    .el-tabs__active-bar {
      display: none;
    }
  }
}
</style>
